import { render, staticRenderFns } from "./DetailText.vue?vue&type=template&id=6cbfbf26&scoped=true&functional=true&"
import script from "./DetailText.vue?vue&type=script&lang=js&"
export * from "./DetailText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6cbfbf26",
  null
  
)

export default component.exports